import { GalleryImage } from "./GalleryImage";

const jrdImagesContext = require.context(
  "../../assets/galleryImages/11_08_24_jrd",
  false,
  /\.(jpg|jpeg|png|webp)$/
);

const makowImagesContext = require.context(
  "../../assets/galleryImages/24_08_24_makow",
  false,
  /\.(jpg|jpeg|png|webp)$/
);

const suchaImagesContext = require.context(
  "../../assets/galleryImages/14_04_24_sucha",
  false,
  /\.(jpg|jpeg|png|webp)$/
);

const rabkaImagesContext = require.context(
  "../../assets/galleryImages/06_04_25_rabka",
  false,
  /\.(jpg|jpeg|png|webp)$/
);

export const jrdSlides: GalleryImage[] = jrdImagesContext
  .keys()
  .map((key: string) => ({
    src: jrdImagesContext(key),
    program: "ticketsList.programFilmMusic",
    description: "11.08.2024 / Jordanów",
  }));

export const makowSlides: GalleryImage[] = makowImagesContext
  .keys()
  .map((key: string) => ({
    src: makowImagesContext(key),
    program: "ticketsList.programFilmMusic",
    description: "24.08.2024 / Maków Podhalański CK",
  }));

export const suchaSlides: GalleryImage[] = suchaImagesContext
  .keys()
  .map((key: string) => ({
    src: suchaImagesContext(key),
    program: "ticketsList.programFilmMusic",
    description: "14.04.2024 / Sucha Beskidzka CK",
  }));

export const rabkaSlides: GalleryImage[] = rabkaImagesContext
  .keys()
  .map((key: string) => ({
    src: rabkaImagesContext(key),
    program: "ticketsList.programFilmMusic",
    description: `06.04.2025 / Rabka-Zdrój "Rabcio"`,
  }));
